import styled from '@emotion/styled';
import {css} from '@emotion/react';
import {colors} from 'patient-ping-remedy/packages/theme';
import Modal from 'patient-ping-remedy/packages/modal';
import Button from 'patient-ping-remedy/packages/button';

const baseModalStyles = css`
  display: flex;
  flex-direction: column;
  width: 850px;
  border-radius: 8px;
  padding: 30px;
  gap: 20px;

  & [class*='header-container'] {
    border-bottom: none;
    padding: 0;
  }

  & [class*='header-text'] {
    padding: 0;
  }

  & [class*='modal-content'] {
    max-height: none;
    overflow: visible;
    padding: 0;
  }

  & [class*='footer-container'] {
    margin: 0;
  }

  & [class*='close-button'] {
    padding-right: 0;
  }

  & [class*='close-button'] svg {
    color: ${colors.purple5} !important;
  }
`;

export const EscalationConfirmationModal = styled(Modal)`
  ${baseModalStyles}
`;

export const EscalationDetailsModal = styled(Modal)`
  ${baseModalStyles}
`;

export const EscalationModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const EscalationCancelButton = styled(Button)`
  color: ${colors.purple5} !important;
`;

